// The ONE place that writes `document.body.style.overflow`. Ref-counted at module scope so
// the LAST panel to close is the one that unlocks — two can be open at once (a confirmation
// raised from inside another panel, or Cookie Settings opened from inside the mobile drawer).
// Shared by `core/Overlay`, `layouts/Sidebar/SidebarMobile` and `widgets/CookieBanner`; a
// second writer that releases with `'unset'` or `''` would unlock the page under a panel
// that is still open.
let openOverlayCount = 0
let bodyOverflowBeforeFirstLock = ''

export function lockBodyScroll(): void {
  if (openOverlayCount === 0) {
    bodyOverflowBeforeFirstLock = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }
  openOverlayCount += 1
}

export function unlockBodyScroll(): void {
  // Clamped: a double-unlock must not drive the count negative and leave the page locked.
  openOverlayCount = Math.max(0, openOverlayCount - 1)
  if (openOverlayCount === 0) {
    document.body.style.overflow = bodyOverflowBeforeFirstLock
  }
}
